import {
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
  FETCH_LOGS_DATE_CHART_REQUEST,
  FETCH_LOGS_DATE_CHART_SUCCESS,
  FETCH_LOGS_DATE_CHART_FAILURE,
  FETCH_LOGS_TYPE_CHART_REQUEST,
  FETCH_LOGS_TYPE_CHART_SUCCESS,
  FETCH_LOGS_TYPE_CHART_FAILURE,
  FETCH_LOGS_FILTER_REQUEST,
  FETCH_LOGS_FILTER_SUCCESS,
  FETCH_LOGS_FILTER_FAILURE
} from '../types/logTypes';

const initialState = {
  logs: { loading: false, data: null, error: null },
  dateChart: { loading: false, data: null, error: null },
  typeChart: { loading: false, data: null, error: null },
  filters: { loading: false, data: null, error: null },
};

const logReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOGS_REQUEST:
      return { ...state, logs: { loading: true, data: null, error: null } };
    case FETCH_LOGS_SUCCESS:
      return { ...state, logs: { loading: false, data: action.payload, error: null } };
    case FETCH_LOGS_FAILURE:
      return { ...state, logs: { loading: false, data: null, error: action.error } };

    case FETCH_LOGS_DATE_CHART_REQUEST:
      return { ...state, dateChart: { loading: true, data: null, error: null } };
    case FETCH_LOGS_DATE_CHART_SUCCESS:
      return { ...state, dateChart: { loading: false, data: action.payload, error: null } };
    case FETCH_LOGS_DATE_CHART_FAILURE:
      return { ...state, dateChart: { loading: false, data: null, error: action.error } };

    case FETCH_LOGS_TYPE_CHART_REQUEST:
      return { ...state, typeChart: { loading: true, data: null, error: null } };
    case FETCH_LOGS_TYPE_CHART_SUCCESS:
      return { ...state, typeChart: { loading: false, data: action.payload, error: null } };
    case FETCH_LOGS_TYPE_CHART_FAILURE:
      return { ...state, typeChart: { loading: false, data: null, error: action.error } };

    case FETCH_LOGS_FILTER_REQUEST:
      return { ...state, filters: { loading: true, data: null, error: null } };
    case FETCH_LOGS_FILTER_SUCCESS:
      return { ...state, filters: { loading: false, data: action.payload, error: null } };
    case FETCH_LOGS_FILTER_FAILURE:
      return { ...state, filters: { loading: false, data: null, error: action.error } };

    default:
      return state;
  }
};

export default logReducer; 